import { useState, useContext } from 'react';
import { SolutionContext } from '@/context/solution.context';

/**
 * Manage logic around allowing a certain number of attempts before showing a captcha.
 *
 * @param immediate - boolean, whether to show captcha immediately, no attempts are relevant
 * @param maxAttempts - number, failed attempts before requiring captcha.
 */
export const useRecaptcha = ({ immediate = false, maxAttempts = 3 } = {}) => {
  const { solution } = useContext(SolutionContext);
  const [attempts, setAttempts] = useState(0);
  const [captchaState, setCaptchaState] = useState('');

  const tooManyAttempts = attempts >= maxAttempts;
  const bypassRecaptcha = !!solution.recaptcha.bypass_all || !process.env.RECAPTCHA_PUBLIC_KEY;
  const requireCaptcha = (immediate || tooManyAttempts) && !bypassRecaptcha;

  const incrementFailedAttempts = () => setAttempts((prev) => prev + 1);

  const onChangeCaptcha = (value) => {
    setCaptchaState(value === null ? '' : value);
  };

  return {
    incrementFailedAttempts, // e.g. called after a failed login attempt
    requireCaptcha, // whether the max number of attempts have failed
    onChangeCaptcha, // handler for when a person is interacting with the recaptcha component
    captchaState, // result coming back from the recaptcha component
    bypassRecaptcha // whether config dictates all captchas should be turned off
  };
};

export default useRecaptcha;
